<template>
  <div>
    <div v-for="(license, index) in downloadedData" :key="index" class="_paper_style">
      <div class="_horizontal_upper_page">
        <div class="_middle_of_header">
          <h3>بسمه تعالی</h3>
          <h3>دانشکده مدیریت دانشگاه تهران</h3>

          <h3>گواهینامه مرکز آموزش های آزاد کاربردی</h3>

          <div class="_lower_part_of_header">
            <div class="_lower_part_of_header">
              <h5>مجوز وزارت علوم:...........................</h5>

              <p>{{ $route.query.code }}</p>
            </div>

            <div class="_lower_part_of_header">
              <h5>تاریخ</h5>

              <p>{{ convertDate(license.printDate, 'fa', 'YYYY/M/D') }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="_horizontal_context">
        <p>گواهی میشود</p>

        <p>
          آقای / خانم
          <span class="_bold_horizontal_context" style="">{{ license.fullName }}</span>

          دارای کد ملی
          <span style="font-size: 15px"> {{ license.nationalCode }} </span>
          <span class="_bold_horizontal_context">دوره <span style="font-size: 15px; font-weight: bold"></span>{{ license.courseTitle }} </span>

          را به مدت <span style="font-size: 25px">300</span> ساعت، در دانشکده مدیریت دانشگاه تهران با موفقیت به پایان رسانده است.
        </p>
      </div>

      <div class="_horizontal_signature">
        {{ license.facultySignature }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'jalali-moment'

export default {
  name: 'home',
  data() {
    return {
      loading: true,
      mode: this.$route.params.type,
    }
  },
  props: {
    peopleLicense: { type: Object, required: false },
    downloadedData: { type: Array, required: false },
  },
  methods: {
    convertDate(date, local, format) {
      let finalTime = moment(date).locale(local).format(format)

      return finalTime
    },
  },
}
</script>

<style scoped>
._vertical_model {
  display: flex;
  justify-content: center;
  align-items: center;
}

._paper_style {
  page-break-after: always;
  padding: 150px 100px 25px 100px;
}

._certificate_info {
  display: flex;
  flex-direction: column;
  gap: 5px;
  text-align: left;
}

._main_context {
  font-size: 16px;
  margin: 16px 0;
  line-height: 35px;
}

._bold_context {
  font-size: 15px;
  font-weight: bold;
}

._main_context p {
  margin-bottom: 0;
}

._english_context {
  margin: 16px 0;
  line-height: 35px;
  font-size: 16px;
  direction: ltr;
  text-align: left;
}

._english_context p {
  margin-bottom: 0;
}

._signature_parent {
  display: flex;
  align-items: center;
  margin-top: 70px;
  gap: 15px;
}

._signature_box {
  display: flex;
  flex-direction: column;
  text-align: center;
}

._signature_context {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 70px;
}

._signature_box p {
  margin-bottom: 0;
}

._horizontal_upper_page {
  text-align: center;
}

._middle_of_header {
  display: flex;
  flex-direction: column;
  text-align: center;
}

._middle_of_header h3 {
  text-align: center;
  /* font-family: IranNastaliq !important; */
  font-size: 25px;
}

._lower_part_of_header {
  display: flex;
  justify-content: center;
  gap: 5px;
}

._lower_part_of_header h5 {
  /* font-family: IranNastaliq !important; */
}

._user_image {
  width: 90px;
  height: 125px;
  border: 1px solid gray;
  border-radius: 4px;
}

._horizontal_context {
  font-size: 16px;
  margin: 16px 0;
  line-height: 35px;
}

._horizontal_context p {
  margin-bottom: 0;
  font-family: IranNastaliq !important ;
  font-size: 30px;
  line-height: 60px;
}

._bold_horizontal_context {
  font-size: 15px;
  font-weight: bold;
  font-family: IranNastaliq !important;
  font-size: 30px;
}

._horizontal_signature {
  display: flex;
  align-items: center;
  margin-top: 20px;
  gap: 25px;
}

._horizontal_signature_box {
  display: flex;
  flex-direction: column;
  text-align: center;
}

._horizontal_signature_box p {
  margin-bottom: 0;
  font-family: IranNastaliq !important;
}
</style>
